import React from 'react'

export const Loader: React.FC = () => {
  return <div className="h-8 w-8 animate-spin rounded-full border-4 border-white border-t-transparent" />
}

export default Loader
